module.exports = __webpack_public_path__ + "media/images/page/step_img02-ea23acac353ebe774cde1ec3c4c9a9e0.svg";